import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/*
 * https://en.wikipedia.org/wiki/Template:Quantities_of_bytes
 */
enum ByteQuantity {
  DECIMAL = 1000,
  BINARY = 1024,
}

const useAudioFileSize = (fileSize: number | null) => {
  const { t } = useTranslation();
  return useMemo(() => {
    if (!fileSize) return;

    const formatFileSize = (size: number): string => {
      if (size <= 0)
        return t('distribution:uploadAudioModal:fileSizeUnits:emptyFile');

      const units = [
        t('distribution:uploadAudioModal:fileSizeUnits:bytes'),
        t('distribution:uploadAudioModal:fileSizeUnits:kb'),
        t('distribution:uploadAudioModal:fileSizeUnits:mb'),
      ];
      const index = Math.floor(Math.log(size) / Math.log(ByteQuantity.DECIMAL));

      return `${parseFloat(
        (size / ByteQuantity.DECIMAL ** index).toFixed(2)
      )} ${units[index]}`;
    };

    return formatFileSize(fileSize);
  }, [fileSize, t]);
};

export default useAudioFileSize;
